import React, { useState, useEffect } from 'react';
import { Viewer, Worker, SpecialZoomLevel } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import findLinksPlugin from "./findLinksPlugin";

import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

const Paper = ({ documentUrl }) => {
    const [windowHeight, setWindowHeight] = useState(window.innerHeight);

    const debounce = (func, wait) => {
        let timeout;
        return (...args) => {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    };

    const updateHeight = () => {
        setWindowHeight(window.innerHeight);
    };

    // Debounce the updateHeight function to avoid frequent updates
    const debouncedUpdateHeight = debounce(updateHeight, 200);

    useEffect(() => {
        window.addEventListener('resize', debouncedUpdateHeight);
        // Initial update
        updateHeight();

        return () => {
            window.removeEventListener('resize', debouncedUpdateHeight);
        };
    }, [debouncedUpdateHeight]);

    const defaultLayoutPluginInstance = defaultLayoutPlugin();
    const findLinksPluginInstance = findLinksPlugin();

    return (
        <Worker workerUrl="https://pdfdeck.com/static/website/js/pdfworker.js">
            <div
                style={{
                    position: 'relative',
                    top: '0',
                    bottom: '0',
                    left: '0',
                    right: '0',
                    border: "none",
                    height: `${windowHeight}px`,
                    width: "100%",
                }}
            >
                <div style={{ position: "relative", height: "100%", width: "100%" }}>
                    <Viewer
                        fileUrl={documentUrl}
                        plugins={[defaultLayoutPluginInstance, findLinksPluginInstance]}
                        defaultScale={SpecialZoomLevel.PageFit}
                    />
                </div>
            </div>
        </Worker>
    );
};

export default Paper;